import { SvgIcon } from '@mui/material';

interface Props {
  className?: string;
}

const SingleAnswerWrong = ({ className }: Props) => (
  <SvgIcon
    className={className}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="cross-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0.5C4.48 0.5 0 4.98 0 10.5C0 16.02 4.48 20.5 10 20.5C15.52 20.5 20 16.02 20 10.5C20 4.98 15.52 0.5 10 0.5ZM11.2086 10.5L16 5.70857L14.7914 4.5L10 9.29143L5.20857 4.5L4 5.70857L8.79143 10.5L4 15.2914L5.20857 16.5L10 11.7086L14.7914 16.5L16 15.2914L11.2086 10.5Z"
      fill="#D50000"
    />
  </SvgIcon>
);

export default SingleAnswerWrong;
